/**
 * What: Shopify "Settings" top-level page shell copy (New pages set) — heading, help modal,
 * and the new Store data section that absorbs former Shopper Intelligence sync/settings content.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentSettingsIndexCopy = {
    settingsIndex: {
        pageTitle: 'Settings',
        storeDataSectionTitle: 'Store data',
        storeDataSectionDescription: 'What TestFeed has synced from Shopify, and how up to date it is.',
        syncingNowTitle: 'Syncing your store now',
        pageErrorTitle: "This page didn't load",
        pageErrorBody: 'Check your connection and try again.',
        retryAction: 'Try again',
        refreshConnection: 'Refresh connection status',
        connectFailed: 'Could not open the TestFeed connection. Refresh the status and try again.',
        disconnectFailed: 'The disconnect could not be confirmed. Refresh the status before trying again.',
        disconnectUnconfirmed: 'The disconnect has not been confirmed. Store data stays unavailable while we check. You can retry disconnecting this same store.',
        cleanupRetryFailed: 'Cleanup could not be restarted. Refresh the status to see what happened.',
        refreshingConnection: 'Checking the current connection. Store actions are unavailable until this finishes.',
        staleConnection: 'The connection status could not be refreshed. Refresh before making another change.',
        storeDisconnected: 'Store data is unavailable while the connection is disconnected or being checked. Reconnect after cleanup to collect fresh data.',
        helpModalHeading: 'How Settings works',
        helpModalBody1: 'This is where your store connects to TestFeed, where you can see what data has synced from Shopify, and where you manage privacy and support.',
        helpModalBody2: 'We only sync store-level settings and order history from Shopify — nothing about individual customers.',
        helpModalBody3: 'Connecting an integration lets TestFeed share data with that tool, like sending test results to the analytics you already use. Nothing connects automatically — each one needs you to manage it yourself.',
    },
};
//# sourceMappingURL=settings-index.js.map